var React = require('react');

function InterestedIconInline (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"width":"48","height":"48","fill":"#CF3630","key":0}),React.createElement("path",{"d":"M26 14H16.01C16.01 20.6667 16.0037 27.3333 16 34C21.3333 34 26.6667 34 32 34C32 29.3333 32 24.6667 32 20L26 14ZM18 32V16H25V21H30V32H18Z","fill":"white","key":1}),React.createElement("rect",{"x":"20","y":"24","width":"8","height":"2","fill":"white","key":2}),React.createElement("rect",{"x":"20","y":"28","width":"4","height":"2","fill":"white","key":3})]);
}

InterestedIconInline.defaultProps = {"width":"48","height":"48","viewBox":"0 0 48 48","fill":"none"};

module.exports = InterestedIconInline;

InterestedIconInline.default = InterestedIconInline;
